import { type LeadQualificationQuestion } from "../../types/lead.types.ts"

/**
 * A lead that was never asked reads back its company's own set, resolved by
 * the server; `[]` means every question was deleted on purpose and must read
 * back genuinely empty.
 */
const leadQualificationQuestions = (
  questions?: LeadQualificationQuestion[] | null
): LeadQualificationQuestion[] => questions ?? []

const isAnswered = (question?: LeadQualificationQuestion | null) =>
  !!question?.answer?.trim()

const answeredQualificationCount = (
  questions?: LeadQualificationQuestion[] | null
): number => (questions ?? []).filter(isAnswered).length

const hasQualificationAnswers = (
  questions?: LeadQualificationQuestion[] | null
): boolean => answeredQualificationCount(questions) > 0

export {
  answeredQualificationCount,
  hasQualificationAnswers,
  isAnswered,
  leadQualificationQuestions
}
